import { call, takeLatest } from 'redux-saga/effects';
import BackendService from 'services/BackendService';
import schemas from 'containers/App/modules/api/schema';
import { api } from 'containers/App/modules/async.saga';
import { eventsEntityActions } from './eventsEntity.slice';
import { parseFetchAllSuccess } from './events.parsers';

function* searchEvents(action) {
	yield call(api, {
		apiFn: ({ data }) => BackendService.searchEvents({ data }),
		parseSuccessResponseFn: parseFetchAllSuccess,
		schema: [schemas.events],
		params: { data: action.payload },
		actions: [
			eventsEntityActions.fetchEventsPending,
			eventsEntityActions.fetchEventsSuccess,
			eventsEntityActions.fetchEventsFailure,
		],
	});
}

export default function* watchEventsSaga() {
	yield takeLatest(eventsEntityActions.fetchEvents, searchEvents);
}
